declare var __webpack_nonce__;
__webpack_nonce__ = window["NONCE"];
import ModulesLoader from "./ModulesLoader";
import "bootstrap";
import "es6-promise/auto";
import "font-awesome/css/font-awesome.css";

export default class Application {
    private readonly modulesLoader: ModulesLoader;

    constructor() {
        this.modulesLoader = new ModulesLoader();
    }

    initialize(): void {
        this.modulesLoader.init();
        this.render();
    }

    private render(): void {
        // initial controls
        $("[data-toggle=\"tooltip\"]").tooltip();

        // show page after render completely
        $("body").fadeIn();

        // hide alert after 5s
        setTimeout(() => {
            $(".alert.auto-close").alert("close");
        }, 15000);
    }
}

let application: Application = new Application();
application.initialize();